export const isArray = (a) => Array.isArray(a);
export const isObject = (o) => typeof o === "object" && !isArray(o) && o !== null;
export const findNodeByKey = (identifier, node) => {
    if (isObject(node) && node[identifier])
        return node[identifier];
    if (isObject(node)) {
        const keys = Object.keys(node);
        for (const key of keys) {
            const _node = findNodeByKey(identifier, node[key]);
            if (_node)
                return _node;
        }
    }
    if (isArray(node)) {
        for (const n of node) {
            const _node = findNodeByKey(identifier, n);
            if (_node)
                return _node;
        }
    }
};
export const getLocalization = () => {
    // Checks if ?locale param is available
    const searchParams = new URLSearchParams(window.location.search);
    const localeParam = searchParams.get("locale");
    if (localeParam) {
        if (localeParam.includes("_")) {
            return parseLocale(localeParam.replace("_", "-"));
        }
        return parseLocale(localeParam);
    }
    // Checks if /country/language/ exists in the URL
    const url = window.location.href;
    const localeRegex = new RegExp(/(\/[a-z]{2}\/[a-z]{2}\/)/);
    const matchLocale = (str) => str.match(localeRegex);
    if (matchLocale(url)) {
        const matchArray = matchLocale(url);
        const getGroup = (num) => {
            return matchArray[num];
        };
        // For some reason country and language are in the reversed order on IKEA.com and this fixes that for us
        const locale = getGroup(0).split("/").filter(Boolean).reverse().join("-");
        return parseLocale(locale);
    }
    // If neither ?locale or /country/language/ exists we will return at default value
    console.warn("Locale not found, defaulting to sv-SE");
    return "sv-SE";
};
const parseLocale = (locale) => {
    const language = getLanguage(locale).toLowerCase();
    const country = getCountry(locale).toUpperCase();
    return `${language}-${country}`;
};
export const getLanguage = (locale) => {
    return (locale || getLocalization()).split("-")[0];
};
export const getCountry = (locale) => {
    return (locale || getLocalization()).split("-")[1];
};
